import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledLessonHeading = styled.div<{
  withBorder?: boolean;
  fontSize?: number;
  color?: string;
  padding?: string;
}>`
  font-size: ${({ fontSize }) => fontSize || 24}px;
  font-weight: 600;
  line-height: 1.6;
  color: ${({ color }) => color || COLORS.blackOlive};
  padding: ${({ padding }) => padding};

  ${({ withBorder }) =>
    withBorder &&
    `
      line-height: 1.33;
      padding: 10px 0;

      &>div {
        border: solid 1px ${COLORS.veryLightPink};
        padding: 20px;
      }
    `}

  p, ul, ol {
    margin: 0;
  }
`;
